import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ad3c372e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Transformar em lista de compras ")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Compartilhar com meus amigos ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon_layout_m",
    src: "/assets/icon/homem.svg"
  })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon_layout_m",
    src: "/assets/icon/mulher.svg"
  })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon_layout_m",
    src: "/assets/icon/crianca.svg"
  })
], -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" CARNES ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" ACOMPANHAMENTOS ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" SUPRIMENTOS ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" BEBIDAS ")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon_layout",
  src: "/assets/icon/churrascometro.svg"
}, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Churrascômetro ")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ion-text-center font-montserrat-bold" }, " QUANTAS PESSOAS VÃO AO CHURRAS? ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon_layout_m",
    src: "/assets/icon/homem.svg"
  })
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon_layout_m",
    src: "/assets/icon/mulher.svg"
  })
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon_layout_m",
    src: "/assets/icon/crianca.svg"
  })
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " HOMENS ", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " MULHERES ", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " CRIANÇAS ", -1))
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ion-text-center" }, " QUAIS CARNES SERÃO SERVIDAS? ", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  id: "Layer_1",
  "enable-background": "new 0 0 480.105 480.105",
  height: "45",
  viewBox: "0 0 480.105 480.105",
  width: "45",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "m437.744 12.095c-9.34-10.71-26.87 2.17-18.59 14.479 8.62 12.8 10.41 27.08 1.76 40.21-39.8 60.39-171.06-29.3-180.35 60.42h-1.04c-9.29-89.72-140.55-.03-180.35-60.42-8.65-13.13-6.86-27.41 1.76-40.21 8.28-12.31-9.25-25.19-18.59-14.479-53.83 61.7-19.9 128.11 46.39 159.92-47.73 47.26-51.69 120.08-31.43 132.06 9.59 5.67 43.46-1.15 71.04-34.56 7.27 42.51 21.51 89.47 32.08 133.35-14.57 28.97 4.63 69.24 42.99 69.24h72.69c38.26 0 57.46-40.06 43.09-69.02l.47-.22c10.57-43.88 24.81-90.84 32.08-133.35 27.58 33.41 61.45 40.23 71.04 34.56 20.26-11.979 16.3-84.8-31.43-132.06 66.291-31.81 100.221-98.22 46.39-159.92z",
    fill: "#ffebd2"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "m428.915 91.785c-35.06 53.2-141.12-10.08-172.21 35.46-1.31-.03-16.14-.04-16.14-.04 9.29-89.72 140.55-.03 180.35-60.42 3.49-5.29 5.27-10.76 5.6-16.25 8.377 15.421 12.112 26.508 2.4 41.25z",
    fill: "#fff3e4"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "m139.105 161.335c-5.1 7.21-8.76 15.4-11.24 24.39-90.762-21.288-148.842-101.051-85.52-173.63 4.09-4.69 9.75-4.86 14.12-2.53-38.991 64.119 9.657 128.128 82.64 151.77z",
    fill: "#fff3e4"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "m276.105 472.105h-72.69c-48.198 0-66.148-63.575-24.87-88.43 36.778-22.158 85.731-22.095 122.42 0 41.284 24.839 23.341 88.43-24.86 88.43z",
    fill: "#ffa4b8"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "m310.375 390.935c-30.385-7.869-64.477-3.74-91.83 12.74-25.271 15.217-29.396 46.448-14.1 68.43-50.4 0-66.585-63.93-25.9-88.43 36.778-22.158 85.731-22.095 122.42 0 3.58 2.15 6.709 4.59 9.41 7.26z",
    fill: "#ffbfcb"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "m319.665 402.865-.47.22c-3.73-7.52-9.72-14.29-18.23-19.41-36.803-22.161-85.75-22.092-122.42 0-8.42 5.07-14.38 11.76-18.12 19.19-30.801-127.87-89.336-275.66 66.94-275.66h25.36c61.46 0 89.7 23.01 99.5 58.52 15.302 55.423-14.416 141.816-32.56 217.14z",
    fill: "#c79a83"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "m332.234 151.225c-21.282-4.949-40.809-4.02-64.87-4.02-61.46 0-89.7 23.01-99.5 58.52-13.085 47.391 7.61 120.876 21.13 172.4-12.525 5.808-22.438 12.558-28.57 24.74-30.801-127.87-89.336-275.66 66.94-275.66h25.36c38.091 0 63.421 8.84 79.51 24.02z",
    fill: "#e0b7a3"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "m391.355 172.015c47.73 47.26 51.69 120.08 31.43 132.06-9.59 5.67-43.46-1.15-71.04-34.56 5.38-31.37 6.96-60.32.48-83.79 13.9-3.26 27.05-7.91 39.13-13.71z",
    fill: "#a07765"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "m127.865 185.725c-6.48 23.47-4.9 52.42.48 83.79-27.58 33.41-61.45 40.23-71.04 34.56-20.26-11.98-16.3-84.8 31.43-132.06 12.079 5.8 25.23 10.45 39.13 13.71z",
    fill: "#a07765"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "m80.185 303.495c-10.43 3.14-18.82 2.98-22.88.58-20.26-11.979-16.3-84.8 31.43-132.06 8.64 4.15 17.83 7.71 27.45 10.59-38.741 40.42-46.89 97.75-36 120.89z",
    fill: "#c79a83"
  }),
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("path", { d: "m203.145 406.663c-4.396-.241-8.168 3.18-8.388 7.593-.696 13.998 8.727 25.993 22.407 28.522 4.297.803 8.511-2.031 9.32-6.412.804-4.344-2.067-8.518-6.412-9.32-5.794-1.072-9.633-6.004-9.335-11.995.221-4.414-3.179-8.169-7.592-8.388z" }),
    /*#__PURE__*/_createElementVNode("path", { d: "m260.016 427.046c-4.345.803-7.216 4.977-6.412 9.32.804 4.351 4.982 7.214 9.32 6.412 13.681-2.529 23.104-14.524 22.407-28.522-.22-4.412-3.986-7.816-8.388-7.593-4.413.22-7.813 3.975-7.593 8.388.299 5.991-3.54 10.922-9.334 11.995z" }),
    /*#__PURE__*/_createElementVNode("path", { d: "m443.775 6.832c-15.933-18.267-45.095 3.647-31.258 24.207 5.158 7.663 9.643 19.32 1.721 31.342-25.854 39.231-102.07 3.744-147.167 17.593-4.224 1.297-6.597 5.771-5.3 9.995 1.297 4.225 5.772 6.601 9.995 5.3 41.009-12.589 123.255 25.35 155.831-24.083 9.963-15.117 9.321-32.548-1.807-49.08-2.73-4.056 3.129-7.963 5.928-4.756 22.543 25.843 29.835 53.863 21.087 81.032-11.188 34.748-48.191 64.712-95.284 77.716-16.033-44.207-58.133-56.896-104.799-56.896h-6.294c-4.041-21.01-15.785-34.35-34.993-39.691-45.317-12.606-119.989 21.708-145.584-17.13-7.922-12.021-3.438-23.679 1.721-31.342 13.837-20.56-15.32-42.477-31.258-24.207-57.845 66.308-22.321 141.992 56.232 175.699 4.06 1.743 8.764-.137 10.506-4.197s-.137-8.764-4.197-10.506c-38.899-16.692-66.316-45.062-73.342-75.889-5.72-25.099 2.185-50.892 22.857-74.59 2.795-3.206 8.658.701 5.928 4.756-11.128 16.532-11.77 33.963-1.807 49.08 41.276 62.63 161.811-15.078 177.566 48.017-97.971 0-125.849 51.214-110.193 147.929-25.711 29.355-53.974 32.73-58.49 30.056-9.889-5.85-12.915-46.691 8.936-87.188 2.099-3.889.647-8.741-3.241-10.839-3.887-2.099-8.742-.648-10.839 3.241-15.858 29.389-30.987 92.003-3.002 108.558 14.609 8.641 46.375-2.023 70.173-24.467 7.587 37.633 19.293 77.399 28.573 115.493-14.673 33.504 7.843 78.121 51.435 78.121h72.693c56.447 0 77.153-74.288 28.987-103.279-12.343-7.431-26.025-12.596-40.33-15.37v-83.46c0-8.793 3.212-17.261 9.045-23.843 7.012-7.916-4.951-18.538-11.977-10.611-8.427 9.513-13.068 21.748-13.068 34.454v81.396c-5.77-.39-11.593-.422-17.432-.045v-81.351c0-12.706-4.642-24.941-13.068-34.454-7.016-7.916-19 2.682-11.977 10.611 5.833 6.582 9.045 15.05 9.045 23.843v90.179c0 4.839 4.262 8.568 9.062 7.93 11.949-1.6 20.945-1.155 31.575.108 14.601 1.735 28.504 6.875 40.873 14.321 34.24 20.609 19.414 73.571-20.735 73.571h-72.692c-40.118 0-54.999-52.948-20.738-73.571 2.554-1.537 5.221-2.986 7.926-4.308 9.503-4.642 2.498-19.024-7.021-14.377-7.862 3.84-13.957 7.579-19.433 12.817-33.53-132.024-73.695-249.464 63.224-249.464h25.355c126.678 0 102.25 100.35 70.016 223.244-2.685 10.237 12.789 14.307 15.477 4.061 6.513-24.829 13.435-51.025 18.473-76.015 24.361 22.976 55.941 32.883 70.173 24.467 20.423-12.082 20.652-59.603.49-101.694-1.908-3.983-6.686-5.668-10.671-3.759-3.984 1.908-5.668 6.687-3.759 10.671 19.242 40.172 14.625 75.786 5.793 81.011-4.515 2.672-32.779-.701-58.49-30.056 4.462-27.562 5.927-53.404 1.543-75.607 94.367-26.001 146.594-110.657 82.007-184.694z" }),
    /*#__PURE__*/_createElementVNode("path", { d: "m177.721 260.46c-10.113-3.123-14.826 12.177-4.708 15.291 8.059 2.481 14.743 7.839 18.823 15.084 5.143 9.137 19.129 1.362 13.941-7.85-6.098-10.833-16.063-18.833-28.056-22.525z" }),
    /*#__PURE__*/_createElementVNode("path", { d: "m302.368 260.46c-11.994 3.692-21.958 11.692-28.058 22.526-5.193 9.228 8.75 17.069 13.943 7.85 4.079-7.246 10.764-12.604 18.822-15.085 10.111-3.112 5.418-18.407-4.707-15.291z" })
  ])
], -1))
const _hoisted_28 = /*#__PURE__*/_createTextVNode("CARNE BOVINA")
const _hoisted_29 = {
  class: "ion-padding",
  slot: "content"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "10 60.984 672.665 560.7",
  width: "45",
  height: "45",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", {
      clipPathUnits: "userSpaceOnUse",
      id: "a"
    }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M0 512h512V0H0z" })
    ])
  ]),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("g", {
    "clip-path": "url(#a)",
    transform: "matrix(1.246158, 0, 0, -1.246939, 33.159344, 665.331055)",
    style: {}
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c-207.341 128.07-42.403 414.121 119.081 414.121S445.503 128.07 238.162 0z",
      style: {"fill":"#fab659","fill-opacity":"1","fill-rule":"nonzero","stroke":"none"},
      transform: "translate(668.92 50.341)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c-4.598.531-9.246.769-13.873.807-.376.003-.752.005-1.127.005-20.185 0-40.425-4.47-59.985-12.542-29.542-12.191-55.82-31.676-77.956-54.565-46.254-47.83-78.169-115.129-78.306-181.291-.116-56.094 22.61-111.37 78.807-153.267a254.222 254.222 0 0 1 18.359-12.456h30C-305.001-289.205-156.342-16.754 0 0",
      style: {"fill":"#ec8d00","fill-opacity":"1","fill-rule":"nonzero","stroke":"none"},
      transform: "translate(803 463.65)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c10.976 29.716 33.562 52.328 59.886 56.854 44.325 7.628 52.223 29.21 69.771 40.922h.001c7.017 4.695 15.585 7.798 28.658 7.798 13.074 0 21.642-3.103 28.659-7.798h.001c17.547-11.712 25.445-33.294 69.771-40.922 62.063-10.671 103.375-121.844 20.65-189.723C484.738-4.798 319.8 281.252 158.316 281.252c-161.483 0-326.421-286.05-119.081-414.121C2.396-102.64-9.831-63.828-6.594-29.127",
      style: {"fill":"none","stroke":"#000","stroke-width":"15","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-dasharray":"none","stroke-opacity":"1"},
      transform: "translate(629.683 183.21)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c-9.132-1.648-16.825-7.75-20.639-16.209-13.856-30.73-39.134-108.115 23.528-166.434L133.745-31.405S105.91 19.109 0 0",
      style: {"fill":"#ffc9d3","fill-opacity":"1","fill-rule":"nonzero","stroke":"none"},
      transform: "translate(45.073 461.945)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c9.132-1.648 16.825-7.75 20.639-16.209 13.856-30.73 39.134-108.115-23.528-166.434L-133.745-31.405S-105.91 19.109 0 0",
      style: {"fill":"#ffc9d3","fill-opacity":"1","fill-rule":"nonzero","stroke":"none"},
      transform: "translate(466.927 461.945)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c-12.204 35.194-32.301 67.452-59.417 94.567-18.961 18.961-40.437 34.49-63.67 46.293-26.874-10.582-35.778-26.727-35.778-26.727L-28.009-37.104C-15.361-25.333-6.3-12.784 0 0",
      style: {"fill":"#ff9db0","fill-opacity":"1","fill-rule":"nonzero","stroke":"none"},
      transform: "translate(492.047 316.407)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c6.3-12.785 15.361-25.333 28.009-37.104l130.856 151.237s-8.904 16.145-35.778 26.727c-23.234-11.803-44.71-27.332-63.67-46.293C32.301 67.451 12.204 35.194 0 0",
      style: {"fill":"#ff9db0","fill-opacity":"1","fill-rule":"nonzero","stroke":"none"},
      transform: "translate(19.953 316.407)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c-8.258 2.991-20.364 5.639-37.326 5.639-5.804 0-12.176-.31-19.157-1.022-8.396-.856-15.502-6.607-18.066-14.648-2.207-6.923-4.212-14.817-5.455-23.272-4.914-33.428 3.897-60.1 26.935-81.541L19.095-11.999C18.89-11.716 13.953-5.054 0 0",
      style: {"fill":"#ff9db0","fill-opacity":"1","fill-rule":"nonzero","stroke":"none"},
      transform: "translate(127.179 422.241)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c8.258 2.991 20.364 5.639 37.326 5.639 5.804 0 12.176-.31 19.157-1.022 8.396-.856 15.502-6.607 18.066-14.648 2.207-6.923 4.213-14.817 5.455-23.272 4.914-33.428-3.897-60.1-26.935-81.541L-19.095-11.999C-18.89-11.716-13.953-5.054 0 0",
      style: {"fill":"#ff9db0","fill-opacity":"1","fill-rule":"nonzero","stroke":"none"},
      transform: "translate(384.821 422.241)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0a254.5 254.5 0 0 1-18.409 16.697c-12.88-.673-22.493-2.928-29.4-5.43C-61.762 6.212-66.699-.449-66.904-.732L5.26-103.577c18.4 17.124 27.715 37.591 28.22 62.165A252 252 0 0 1 0 0",
      style: {"fill":"#ff889e","fill-opacity":"1","fill-rule":"nonzero","stroke":"none"},
      transform: "translate(432.63 410.974)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c.505-24.575 9.82-45.041 28.22-62.166L100.384 40.68c-.205.282-5.142 6.944-19.095 11.999-6.907 2.501-16.52 4.757-29.401 5.43A254.487 254.487 0 0 1 33.48 41.412 252 252 0 0 1 0 0",
      style: {"fill":"#ff889e","fill-opacity":"1","fill-rule":"nonzero","stroke":"none"},
      transform: "translate(45.89 369.563)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c0-124.15-100.643-188.607-224.793-188.607-124.149 0-224.793 64.457-224.793 188.607s100.644 224.793 224.793 224.793C-100.643 224.793 0 124.15 0 0",
      style: {"fill":"#ffc9d3","fill-opacity":"1","fill-rule":"nonzero","stroke":"none"},
      transform: "translate(480.793 234.344)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0a64.85 64.85 0 0 1-55.302 0c-19.231-9.079-41.432-26.924-41.432-60.934 0-31.045 39.051-33.689 62.87-22.779a14.957 14.957 0 0 0 12.426 0c23.819-10.91 62.87-8.266 62.87 22.779C41.432-26.924 19.231-9.079 0 0",
      style: {"fill":"#ff889e","fill-opacity":"1","fill-rule":"nonzero","stroke":"none"},
      transform: "translate(283.651 261.644)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0h-21.687a7.5 7.5 0 0 0 0 15H0A7.5 7.5 0 0 0 0 0",
      style: {"fill":"#ff9db0","fill-opacity":"1","fill-rule":"nonzero","stroke":"none"},
      transform: "translate(149.59 199.978)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0h-21.687a7.5 7.5 0 0 0 0 15H0a7.5 7.5 0 0 0 7.5-7.5A7.5 7.5 0 0 0 0 0",
      style: {"fill":"#ff9db0","fill-opacity":"1","fill-rule":"nonzero","stroke":"none"},
      transform: "translate(384.097 199.978)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0a64.85 64.85 0 0 1-55.302 0c-19.231-9.079-41.432-26.924-41.432-60.934 0-31.045 39.051-33.689 62.87-22.779a14.957 14.957 0 0 0 12.426 0c23.819-10.91 62.87-8.266 62.87 22.779C41.432-26.924 19.231-9.079 0 0z",
      style: {"fill":"none","stroke":"#000","stroke-width":"15","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-dasharray":"none","stroke-opacity":"1"},
      transform: "translate(283.65 261.644)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0v-18.349",
      style: {"fill":"none","stroke":"#000","stroke-width":"15","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-dasharray":"none","stroke-opacity":"1"},
      transform: "translate(152.516 252.797)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0v-18.349",
      style: {"fill":"none","stroke":"#000","stroke-width":"15","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-dasharray":"none","stroke-opacity":"1"},
      transform: "translate(359.483 252.797)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c-7.208 4.921-18.189 1.385-24.526-7.898s-5.63-20.797 1.578-25.718c7.209-4.921 18.189-1.385 24.526 7.898S7.208-4.921 0 0",
      style: {"fill":"#000","fill-opacity":"1","fill-rule":"nonzero","stroke":"none"},
      transform: "translate(240.151 232.383)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c7.208 4.921 18.189 1.385 24.526-7.898s5.63-20.797-1.578-25.718c-7.209-4.921-18.189-1.385-24.526 7.898S-7.208-4.921 0 0",
      style: {"fill":"#000","fill-opacity":"1","fill-rule":"nonzero","stroke":"none"},
      transform: "translate(271.848 232.383)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c-9.211-.629-19.158-1.837-29.932-3.781-9.131-1.648-16.824-7.75-20.639-16.21-13.061-28.967-36.257-99.385 13.606-156.216C-19.578-107.31 29.611-51.07 94.083-24.016 83.527-14.642 63.263-2.396 28.004.086",
      style: {"fill":"none","stroke":"#000","stroke-width":"15","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-dasharray":"none","stroke-opacity":"1"},
      transform: "translate(75.004 465.726)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0a66.758 66.758 0 0 1-3.378 1.337c-8.258 2.991-20.365 5.639-37.326 5.639-5.804 0-12.176-.309-19.157-1.022-8.397-.856-15.502-6.607-18.066-14.648-2.207-6.923-4.213-14.817-5.455-23.272-3.084-20.981-.759-39.299 7.095-55.335C-58.866-51.962-32.444-21.858 0 0z",
      style: {"fill":"none","stroke":"#000","stroke-width":"15","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-dasharray":"none","stroke-opacity":"1"},
      transform: "translate(130.557 420.904)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c49.863 56.831 26.667 127.25 13.606 156.216-3.814 8.46-11.507 14.562-20.639 16.21-72.746 13.125-108.657-6.596-124.014-20.235C-66.576 125.137-17.387 68.897 0 0z",
      style: {"fill":"none","stroke":"#000","stroke-width":"15","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-dasharray":"none","stroke-opacity":"1"},
      transform: "translate(473.96 289.52)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c7.854 16.036 10.18 34.354 7.096 55.335C5.853 63.79 3.847 71.684 1.64 78.607c-2.564 8.041-9.669 13.792-18.066 14.648-6.981.712-13.352 1.022-19.157 1.022-16.961 0-29.068-2.649-37.326-5.639a68.1 68.1 0 0 1-3.378-1.337C-43.843 65.442-17.421 35.338 0 0z",
      style: {"fill":"none","stroke":"#000","stroke-width":"15","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-dasharray":"none","stroke-opacity":"1"},
      transform: "translate(457.73 333.603)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c9.811 22.267 15.203 47.777 15.203 76.487 0 124.15-100.643 224.793-224.793 224.793S-434.383 200.637-434.383 76.487-333.74-112.12-209.59-112.12c83.524 0 156.405 29.177 195.162 86.076",
      style: {"fill":"none","stroke":"#000","stroke-width":"15","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-dasharray":"none","stroke-opacity":"1"},
      transform: "translate(465.59 157.857)"
    })
  ])
], -1))
const _hoisted_31 = /*#__PURE__*/_createTextVNode("CARNE SUINA")
const _hoisted_32 = {
  class: "ion-padding",
  slot: "content"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "11.161 10.877 167.337 151.72",
  width: "45",
  height: "45",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", {
      clipPathUnits: "userSpaceOnUse",
      id: "a"
    }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M0 512h512V0H0z" })
    ])
  ]),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("g", {
    "clip-path": "url(#a)",
    transform: "matrix(0.314831, 0, 0, -0.294981, 13.197357, 162.252579)",
    style: {}
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c0 19.105-9.214 35.994-23.324 46.293a57.761 57.761 0 0 1 4.915 23.375c0 31.377-24.828 56.814-55.452 56.814-30.626 0-55.453-25.437-55.453-56.814 0-12.017 3.651-23.153 9.867-32.328-.45.014-.901.034-1.354.034-15.675 0-29.329-8.565-36.508-21.239a54.145 54.145 0 0 1-20.107 3.856c-10.718 0-20.719-3.127-29.201-8.52-10.167 12.77-25.645 20.927-42.986 20.927-28.359 0-51.732-21.817-55.035-49.962-7.701 21.898-28.152 37.555-52.176 37.555-11.159 0-21.54-3.39-30.238-9.2a57.353 57.353 0 0 1-4.752 14.433c12.749 10.409 20.93 26.444 20.93 44.444 0 31.377-24.826 56.814-55.451 56.814-30.626 0-55.452-25.437-55.452-56.814 0-9.063 2.082-17.623 5.764-25.223-12.75-10.408-20.93-26.443-20.93-44.445 0-23.87 14.376-44.287 34.733-52.698a57.997 57.997 0 0 1-3.23-19.129c0-29.82 22.427-54.257 50.94-56.61 3.477-27.953 26.761-49.567 54.987-49.567a54.105 54.105 0 0 1 20.077 3.857c8.836-19.365 28.01-32.788 50.251-32.788 15.508 0 29.521 6.528 39.582 17.042 10.066-10.514 24.079-17.042 39.585-17.042 22.372 0 41.634 13.581 50.401 33.127a54.105 54.105 0 0 1 20.919-4.196c29.711 0 53.962 23.942 55.383 54.019 24.367 5.984 42.486 28.437 42.486 55.236 0 4.664-.562 9.191-1.595 13.528C-18.088-49.215 0-26.778 0 0",
      style: {"fill":"#fff1cf","fill-opacity":"1","fill-rule":"nonzero","stroke":"none"},
      transform: "translate(504.5 214.536)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0a57.112 57.112 0 0 0 8.305-15.469 57.472 57.472 0 0 0 2.839 12.304A54.172 54.172 0 0 1 0 0",
      style: {"fill":"#a8a8a8","fill-opacity":"1","fill-rule":"nonzero","stroke":"none"},
      transform: "translate(336.251 233.753)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0a54.111 54.111 0 0 0-20.077-3.855c-28.227 0-51.512 21.613-54.987 49.566-28.514 2.353-50.942 26.792-50.942 56.61a57.993 57.993 0 0 0 3.232 19.129c-19.926 8.231-34.109 27.966-34.706 51.182a54.925 54.925 0 0 1-4.591.195c-11.158 0-21.539-3.39-30.238-9.2a57.353 57.353 0 0 1-4.752 14.433c12.749 10.409 20.93 26.444 20.93 44.444 0 31.377-24.826 56.814-55.451 56.814-30.626 0-55.452-25.437-55.452-56.814 0-9.063 2.082-17.623 5.764-25.223-12.75-10.408-20.93-26.443-20.93-44.445 0-23.87 14.376-44.287 34.733-52.698a57.997 57.997 0 0 1-3.23-19.129c0-29.821 22.427-54.257 50.94-56.61 3.477-27.953 26.761-49.567 54.987-49.567a54.13 54.13 0 0 1 20.078 3.856c8.836-19.364 28.009-32.787 50.251-32.787 15.507 0 29.52 6.528 39.582 17.042 10.065-10.514 24.078-17.042 39.585-17.042 19.103 0 35.935 9.911 45.905 24.975C17.098-23.873 6.092-13.349 0 0",
      style: {"fill":"#ffeab7","fill-opacity":"1","fill-rule":"nonzero","stroke":"none"},
      transform: "translate(309.757 61.7)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c.306.732 40.444-19.606 43.166-21.09 15.817-8.619 44.382-22.474 50.662-41.449 9.165-27.71-68.953-20.553-79.18-19.196-3.959.526-44.194 10.275-43.511 11.922C-28.851-69.778-.021-.054 0 0",
      style: {"fill":"#eaaa83","fill-opacity":"1","fill-rule":"nonzero","stroke":"none"},
      transform: "translate(409.437 379.095)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c-6.28 18.973-34.846 32.828-50.661 41.447-1.248.681-10.337 5.313-19.857 10.064 5.43 13.129 9.91 23.968 9.918 23.989.306.732 40.445-19.606 43.166-21.09 15.818-8.619 44.382-22.474 50.663-41.449C37.867-1.065 20.141-6.155.178-7.59.951-5.409.957-2.897 0 0",
      style: {"fill":"#e4996d","fill-opacity":"1","fill-rule":"nonzero","stroke":"none"},
      transform: "translate(470.036 303.595)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c-.305.733-40.441-19.606-43.166-21.089-15.815-8.619-44.381-22.474-50.66-41.449-9.167-27.71 68.951-20.554 79.179-19.196 3.959.525 44.194 10.274 43.513 11.921C28.853-69.777.021-.054 0 0",
      style: {"fill":"#eaaa83","fill-opacity":"1","fill-rule":"nonzero","stroke":"none"},
      transform: "translate(102.072 379.043)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c0-74.25-68.688-134.442-153.418-134.442-84.729 0-153.418 60.192-153.418 134.442 0 74.251 68.689 134.444 153.418 134.444C-68.688 134.444 0 74.251 0 0",
      style: {"fill":"#ffd3bc","fill-opacity":"1","fill-rule":"nonzero","stroke":"none"},
      transform: "translate(409.446 268.56)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c0 64.61 52.014 118.569 121.346 131.494a175.041 175.041 0 0 1-32.07 2.95C4.547 134.444-64.142 74.251-64.142 0c0-74.25 68.689-134.442 153.418-134.442 11 0 21.727 1.023 32.07 2.95C52.014-118.568 0-64.609 0 0",
      style: {"fill":"#ffbe9c","fill-opacity":"1","fill-rule":"nonzero","stroke":"none"},
      transform: "translate(166.752 268.56)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c6.279 18.973 34.846 32.828 50.66 41.447 1.247.68 10.338 5.313 19.856 10.064l-9.918 23.988c-.305.733-40.442-19.606-43.166-21.089-15.816-8.619-44.381-22.474-50.661-41.449C-37.868-1.065-20.143-6.155-.18-7.59-.952-5.409-.958-2.897 0 0",
      style: {"fill":"#e4996d","fill-opacity":"1","fill-rule":"nonzero","stroke":"none"},
      transform: "translate(41.475 303.544)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c0-27.717-29.682-50.186-66.297-50.186-36.614 0-66.296 22.469-66.296 50.186 0 27.716 29.682 50.186 66.296 50.186C-29.682 50.186 0 27.716 0 0",
      style: {"fill":"#ffbe9c","fill-opacity":"1","fill-rule":"nonzero","stroke":"none"},
      transform: "translate(321.213 164.516)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c0 21.159 17.306 39.246 41.782 46.626-7.585 2.288-15.851 3.56-24.514 3.56-36.615 0-66.296-22.47-66.296-50.186 0-27.717 29.681-50.186 66.296-50.186 8.663 0 16.929 1.271 24.514 3.558C17.306-39.246 0-21.159 0 0",
      style: {"fill":"#eaaa83","fill-opacity":"1","fill-rule":"nonzero","stroke":"none"},
      transform: "translate(237.648 164.516)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c0 32.276-26.165 58.441-58.441 58.441-4.297 0-8.482-.477-12.515-1.357-9.573 13.899-25.59 23.018-43.743 23.018a52.787 52.787 0 0 1-28.174-8.113c-13.137 13.372-31.416 21.675-51.642 21.675-20.359 0-38.743-8.416-51.897-21.944a52.829 52.829 0 0 1-28.627 8.382c-19.053 0-35.747-10.046-45.113-25.121a58.599 58.599 0 0 1-10.518.962c-32.276 0-58.441-26.165-58.441-58.441 0-20.801 10.876-39.05 27.242-49.407a53.325 53.325 0 0 1-.941-9.928c0-29.321 23.77-53.092 53.093-53.092a52.844 52.844 0 0 1 23.929 5.702c4.627-24.602 26.214-43.221 52.162-43.221 20.128 0 37.639 11.202 46.642 27.711 9.681-12.954 25.137-21.338 42.554-21.338 23.158 0 42.843 14.833 50.099 35.511 7.648-3.268 16.193-4.842 25.164-4.238 26.46 1.783 48.028 22.802 50.499 49.205a54.476 54.476 0 0 1-2.088 20.94C-8.066-33.934 0-17.912 0 0",
      style: {"fill":"#fff1cf","fill-opacity":"1","fill-rule":"nonzero","stroke":"none"},
      transform: "translate(451.765 410.734)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0a52.832 52.832 0 0 0-23.929-5.702c-29.323 0-53.092 23.77-53.092 53.092 0 3.393.332 6.711.94 9.927-16.366 10.358-27.242 28.607-27.242 49.408 0 32.276 26.165 58.441 58.441 58.441a58.69 58.69 0 0 0 10.518-.962c9.366 15.074 26.06 25.12 45.113 25.12a53.43 53.43 0 0 0 4.566-.202c-11.922 8.647-26.569 13.765-42.423 13.765-20.36 0-38.744-8.416-51.898-21.945a52.829 52.829 0 0 1-28.627 8.382c-19.053 0-35.747-10.046-45.113-25.12a58.69 58.69 0 0 1-10.518.962c-32.276 0-58.441-26.165-58.441-58.441 0-20.801 10.876-39.05 27.242-49.408a53.399 53.399 0 0 1-.94-9.927c0-29.322 23.769-53.092 53.092-53.092A52.832 52.832 0 0 1-118.382 0c4.627-24.603 26.214-43.222 52.162-43.222 20.128 0 37.639 11.202 46.642 27.711C-9.896-28.465 5.56-36.849 22.977-36.849c1.252 0 2.492.052 3.722.137C13.008-29.207 2.981-15.851 0 0",
      style: {"fill":"#ffeab7","fill-opacity":"1","fill-rule":"nonzero","stroke":"none"},
      transform: "translate(284.358 301.512)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0a54.106 54.106 0 0 1 24.383-5.776c7.082 0 13.85 1.376 20.077 3.856 8.836-19.364 28.01-32.787 50.251-32.787 15.508 0 29.52 6.527 39.582 17.042 10.065-10.515 24.078-17.042 39.585-17.042 22.371 0 41.634 13.581 50.4 33.127a54.109 54.109 0 0 1 20.919-4.196c29.711 0 53.962 23.941 55.383 54.018 24.367 5.985 42.486 28.438 42.486 55.237 0 4.664-.561 9.191-1.594 13.528 24.336 6.006 42.424 28.442 42.424 55.221 0 19.105-9.214 35.994-23.325 46.293a57.741 57.741 0 0 1 4.915 23.375c0 4.465-.503 8.811-1.454 12.98",
      style: {"fill":"none","stroke":"#000","stroke-width":"15","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-dasharray":"none","stroke-opacity":"1"},
      transform: "translate(120.605 42.309)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0a58.242 58.242 0 0 1-1.62-13.688c0-9.062 2.082-17.623 5.765-25.222-12.75-10.408-20.931-26.444-20.931-44.445 0-23.871 14.376-44.288 34.733-52.699a57.992 57.992 0 0 1-3.23-19.129c0-29.82 22.428-54.256 50.94-56.609a57.47 57.47 0 0 1 6.089-19.537",
      style: {"fill":"none","stroke":"#000","stroke-width":"15","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-dasharray":"none","stroke-opacity":"1"},
      transform: "translate(24.343 297.892)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c8.796-4.402 16.784-8.476 17.947-9.109 15.818-8.62 44.382-22.475 50.662-41.45C77.774-78.269-.344-71.111-10.57-69.755c-1.428.19-7.575 1.579-14.819 3.356",
      style: {"fill":"none","stroke":"#000","stroke-width":"15","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-dasharray":"none","stroke-opacity":"1"},
      transform: "translate(434.655 367.114)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0a119 119 0 0 0 4.46-32.313c0-55.085-37.805-102.433-91.918-123.206",
      style: {"fill":"none","stroke":"#000","stroke-width":"15","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-dasharray":"none","stroke-opacity":"1"},
      transform: "translate(404.986 300.873)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c-51.094 21.817-86.3 67.771-86.3 120.928 0 12.762 2.029 25.109 5.821 36.807",
      style: {"fill":"none","stroke":"#000","stroke-width":"15","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-dasharray":"none","stroke-opacity":"1"},
      transform: "translate(188.91 147.632)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c-8.422-4.221-15.896-8.032-17.019-8.644-15.815-8.619-44.38-22.474-50.66-41.449-9.167-27.71 68.951-20.553 79.179-19.196 1.534.204 8.517 1.793 16.455 3.759",
      style: {"fill":"none","stroke":"#000","stroke-width":"15","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-dasharray":"none","stroke-opacity":"1"},
      transform: "translate(75.925 366.598)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c0-27.717-29.682-50.186-66.297-50.186-36.614 0-66.296 22.469-66.296 50.186 0 27.716 29.682 50.186 66.296 50.186C-29.682 50.186 0 27.716 0 0z",
      style: {"fill":"none","stroke":"#000","stroke-width":"15","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-dasharray":"none","stroke-opacity":"1"},
      transform: "translate(321.213 164.516)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0v-12.585",
      style: {"fill":"none","stroke":"#000","stroke-width":"15","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-dasharray":"none","stroke-opacity":"1"},
      transform: "translate(189.417 243.016)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0v-12.585",
      style: {"fill":"none","stroke":"#000","stroke-width":"15","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-dasharray":"none","stroke-opacity":"1"},
      transform: "translate(320.416 243.016)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c4.198-4.816 10.378-7.864 17.267-7.864 6.893 0 13.07 3.048 17.27 7.864",
      style: {"fill":"none","stroke":"#000","stroke-width":"15","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-dasharray":"none","stroke-opacity":"1"},
      transform: "translate(237.648 170.87)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c8.981-9.571 15.391-21.586 18.124-34.94",
      style: {"fill":"none","stroke":"#000","stroke-width":"15","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-dasharray":"none","stroke-opacity":"1"},
      transform: "translate(308.892 482.724)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c2.913 13.483 9.581 25.568 18.855 35.106",
      style: {"fill":"none","stroke":"#000","stroke-width":"15","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-dasharray":"none","stroke-opacity":"1"},
      transform: "translate(186.497 447.348)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c-10.176-8.597-23.329-13.779-37.693-13.779-10.908 0-21.117 2.988-29.854 8.189",
      style: {"fill":"none","stroke":"#000","stroke-width":"15","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-dasharray":"none","stroke-opacity":"1"},
      transform: "translate(431.009 366.081)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0a58.277 58.277 0 0 0-22.225-4.374c-11.477 0-22.181 3.309-31.212 9.023",
      style: {"fill":"none","stroke":"#000","stroke-width":"15","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-dasharray":"none","stroke-opacity":"1"},
      transform: "translate(143.332 354.18)"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0c0 32.276-26.165 58.441-58.441 58.441-4.297 0-8.482-.477-12.515-1.357-9.573 13.899-25.59 23.018-43.743 23.018a52.787 52.787 0 0 1-28.174-8.113c-13.137 13.372-31.416 21.675-51.642 21.675-20.359 0-38.743-8.416-51.897-21.944a52.829 52.829 0 0 1-28.627 8.382c-19.053 0-35.747-10.046-45.113-25.121a58.599 58.599 0 0 1-10.518.962c-32.276 0-58.441-26.165-58.441-58.441 0-20.801 10.876-39.05 27.242-49.407a53.325 53.325 0 0 1-.941-9.928c0-29.321 23.77-53.092 53.093-53.092a52.844 52.844 0 0 1 23.929 5.702c4.627-24.602 26.214-43.221 52.162-43.221 20.128 0 37.639 11.202 46.642 27.711 9.681-12.954 25.137-21.338 42.554-21.338 23.158 0 42.843 14.833 50.099 35.511 7.648-3.268 16.193-4.842 25.164-4.238 26.46 1.783 48.028 22.802 50.499 49.205a54.476 54.476 0 0 1-2.088 20.94C-8.066-33.934 0-17.912 0 0z",
      style: {"fill":"none","stroke":"#000","stroke-width":"15","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-dasharray":"none","stroke-opacity":"1"},
      transform: "translate(451.765 410.734)"
    })
  ])
], -1))
const _hoisted_34 = /*#__PURE__*/_createTextVNode("CARNE OVINA")
const _hoisted_35 = {
  class: "ion-padding",
  slot: "content"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  height: "45",
  viewBox: "0 0 479.992 479.992",
  width: "45",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M328.083 160.132c-.101 0-4.441-15.302-7.41-31.56-2.97-16.24-9.57-29.56-18.5-39.94 9.52-5.96 15.86-16.55 15.86-28.62 0-22.79-22.14-38.95-43.77-32.23-15.86-26.37-54.09-26.37-69.94 0-21.6-6.71-43.77 9.39-43.77 32.23 0 12.46 6.74 23.34 16.78 29.18-8.69 10.3-15.11 23.43-18.02 39.38-2.974 16.282-7.31 31.56-7.41 31.56-139.86-13.19-158.12 219.1-73.21 212.8.57 14.12 3.42 28.69 9.22 44.05 12.51 33.11 44.25 55.01 79.65 55.01h144.86c35.4 0 67.14-21.9 79.65-55.01 5.8-15.36 8.65-29.93 9.22-44.05 84.91 6.3 66.65-225.99-73.21-212.8z",
    fill: "#ffe773"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M424.596 238.52c-17.746-26.971-44.754-46.891-81.438-48.782-3.259-.168-6.111-2.229-7.215-5.299-2.827-7.862-5.475-15.953-7.86-24.307 55.903-5.272 92.38 28.676 110.604 70.931 3.874 8.984-8.713 15.631-14.091 7.457z",
    fill: "#fff0a6"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M410.51 372.647c-2.923.419-5.996.522-9.217.285 2.8-69.08-48.77-127.26-73.21-212.8 3.584-.338 7.086-.516 10.511-.537 3.512-.022 6.651 2.213 7.71 5.562 23.951 75.739 69.777 131.999 71.071 199.484.077 4.009-2.895 7.437-6.865 8.006z",
    fill: "#facf5f"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M261.405 63.674c10.168 2.598 9.764 17.127-.475 19.432-31.184 7.021-55.215 30.369-61.618 65.467-2.974 16.282-7.31 31.56-7.41 31.56-21.873 76.557-100.174 183.632-64.656 259.159 4.588 9.757-7.479 18.853-15.614 11.777a84.842 84.842 0 0 1-23.72-34.086c-37.557-99.463 49.035-165.96 71.4-288.41 2.91-15.95 9.33-29.08 18.02-39.38 20.74-24.593 54.397-33.101 84.073-25.519z",
    fill: "#fff0a6"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M151.903 160.132a378.373 378.373 0 0 1-6.423 20.242 8.042 8.042 0 0 1-5.39 5.097C70.683 205.284 45.101 296.5 59.258 351.858c2.09 8.173-8.274 13.594-13.795 7.216-42.493-49.087-10.609-209.979 106.44-198.942z",
    fill: "#fff0a6"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M78.693 372.932c-3.221.237-6.294.134-9.217-.285-3.97-.569-6.942-3.997-6.865-8.006 1.295-67.513 47.081-123.644 71.071-199.484 1.059-3.349 4.198-5.583 7.71-5.561 3.425.021 6.927.199 10.511.537-24.44 85.539-76.01 143.719-73.21 212.799z",
    fill: "#facf5f"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M252.243 167.172c7.66 2.77 11.14 11.68 7.66 19.05l-7.62 16.18c-5.12 10.85-20.62 10.66-25.47-.31l-7.12-16.1c-3.32-7.51.26-16 7.98-18.82 7.97-2.91 16.71-2.84 24.57 0z",
    fill: "#fa9a4b"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M252.369 167.219c4.68 1.748 3.976 8.538-.911 9.577a35.407 35.407 0 0 0-4.786 1.376c-7.72 2.82-11.3 11.31-7.98 18.82l2.625 5.935c1.714 3.874-1.885 8.121-5.932 6.866-3.597-1.116-6.8-3.688-8.574-7.701l-7.12-16.1c-3.32-7.51.26-16 7.98-18.82 8.209-2.996 17.173-2.764 24.698.047z",
    fill: "#ffaa64"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M318.033 60.012c0 12.07-6.34 22.66-15.86 28.62-31.85-37.04-93.29-36.85-124.84.56-10.04-5.84-16.78-16.72-16.78-29.18 0-22.84 22.17-38.94 43.77-32.23 15.85-26.37 54.08-26.37 69.94 0 21.63-6.72 43.77 9.44 43.77 32.23z",
    fill: "#ff6d7a"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M248.838 23.437a40.077 40.077 0 0 0-11.625 10.131c-1.799 2.308-4.659 3.586-7.547 3.111-21.13-3.472-40.574 13.889-39.055 35.531a8.143 8.143 0 0 1-3.014 6.911 75.967 75.967 0 0 0-10.263 10.072c-10.04-5.84-16.78-16.72-16.78-29.18 0-22.84 22.17-38.94 43.77-32.23 9.296-15.466 26.294-21.86 41.961-19.18 7.385 1.262 9.045 11.092 2.553 14.834z",
    fill: "#ff8c95"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M447.533 231.484c-14.518-35.925-39.342-61.936-69.898-73.242a8 8 0 1 0-5.552 15.006c87.516 32.378 93.18 196.401 29.806 191.707-4.55-.335-8.405 3.174-8.585 7.655-.563 13.95-3.412 27.539-8.708 41.545-11.271 29.808-40.273 49.836-72.17 49.836H167.561c-31.896 0-60.9-20.028-72.17-49.836-21.582-57.078.638-103.901 26.366-158.118 13.146-27.702 26.724-58.529 37.714-93.295.495-1.564 5.397-20.027 7.716-32.732 14.829-81.242 130.779-81.255 145.61 0 14.315 78.419 54.315 134.091 71.991 188.326a8 8 0 0 0 15.213-4.958c-18.247-55.981-57.564-110.09-71.464-186.241-2.678-14.674-8.034-27.014-15.178-37.17 18.178-17.575 16.87-47.944-4.318-63.548-9.171-6.754-20.301-9.424-31.281-7.655-19.417-25.014-57.523-25.026-76.947.008-19.263-3.054-38.537 7.76-45.596 26.484a8 8 0 0 0 14.972 5.644c4.796-12.72 18.745-19.518 31.757-15.475a7.997 7.997 0 0 0 9.229-3.517c12.746-21.197 43.471-21.214 56.228 0a7.997 7.997 0 0 0 9.229 3.517c7.89-2.452 16.244-1.039 22.92 3.878 12.783 9.415 13.832 27.556 3.366 38.488-47.437-45.657-137.417-27.653-151.472 49.347a321.678 321.678 0 0 1-5.512 24.589C31.296 146.914-3.797 298.352 34.221 357.356a7.994 7.994 0 0 0 6.732 3.668c6.244 0 10.174-6.971 6.718-12.334-17.454-27.089-17.627-86.544 9.933-131.876 14.074-23.148 39.801-49.565 83.716-49.214-30.492 96.39-95.469 160.775-60.895 252.215 13.609 35.994 48.627 60.177 87.136 60.177h144.863c38.51 0 73.527-24.183 87.137-60.177 4.949-13.092 7.985-25.898 9.215-38.929 23.837-1.996 41.735-21.264 48.658-53.086 6.359-29.232 2.657-65.238-9.901-96.316z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M220.993 137.992v-13a8 8 0 0 0-16 0v13a8 8 0 0 0 16 0zM272.993 137.992v-13a8 8 0 0 0-16 0v13a8 8 0 0 0 16 0zM219.497 205.325c7.626 17.245 31.984 17.531 40.021.483l7.624-16.173c5.491-11.647-.117-25.621-12.179-29.983-9.726-3.517-20.394-3.514-30.039.01-12.078 4.413-17.741 17.813-12.546 29.562zm10.917-30.635c6.123-2.236 12.909-2.234 19.107.008 3.247 1.175 4.601 5.029 3.147 8.114l-7.624 16.174c-2.202 4.668-8.832 4.578-10.915-.131l-7.12-16.102c-1.447-3.276.03-6.829 3.405-8.063zM146.908 364.016a8 8 0 0 0-10.892 3.062c-11.34 20.208 2.083 41.528 22.939 43.352 2.694 21.337 24.747 32.203 45.603 25.141a8 8 0 1 0-5.131-15.155c-13.065 4.424-26.651-2.507-24.517-17.278.796-5.511-4.155-10.138-9.601-8.965-11.872 2.554-21.806-7.742-15.34-19.264a8.001 8.001 0 0 0-3.061-10.893zM275.427 435.57c20.778 7.036 42.901-3.74 45.603-25.141 20.851-1.824 34.283-23.136 22.939-43.352a8.001 8.001 0 0 0-13.954 7.83c6.449 11.492-3.439 21.825-15.34 19.264-5.451-1.169-10.397 3.454-9.602 8.965 2.125 14.702-11.398 21.72-24.517 17.279a8 8 0 1 0-5.129 15.155z" })
], -1))
const _hoisted_37 = /*#__PURE__*/_createTextVNode("CARNE DE FRANGO")
const _hoisted_38 = {
  class: "ion-padding",
  slot: "content"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ion-text-center" }, " VOCÊ PENSOU EM QUAIS ACOMPANHAMENTOS? ", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ion-text-center" }, " NÃO ESQUEÇA DOS SUPRIMENTOS ", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ion-text-center" }, " QUAIS BEBIDAS DESEJA SERVIR? ", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_47 = /*#__PURE__*/_createTextVNode("Calcular Churrasco")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SafeArea = _resolveComponent("SafeArea")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_list_header = _resolveComponent("ion-list-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_accordion = _resolveComponent("ion-accordion")!
  const _component_ion_accordion_group = _resolveComponent("ion-accordion-group")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_modal, {
        ref: "modal",
        trigger: "open-modal",
        "is-open": _ctx.calculoChurrasco
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SafeArea, {
            onOnBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setOpen(false))),
            data: {'cart': false}
          }),
          _createVNode(_component_ion_content, { class: "ion-padding" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, { class: "ion-align-items-center ion-text-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    size: "5",
                    class: "to-list",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goTranformar()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: _ctx.icon_lista }, null, 8, ["icon"]),
                      _hoisted_1,
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, { size: "2" }),
                  _createVNode(_component_ion_col, {
                    size: "5",
                    class: "to-share",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goShare()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: _ctx.icon_share }, null, 8, ["icon"]),
                      _hoisted_3,
                      _hoisted_4
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "ion-align-items-center churrascometro" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "4" }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, { size: "4" }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, { size: "4" }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "ion-align-items-center ion-text-center font-montserrat-bold" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "4" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, _toDisplayString(_ctx.churrascometro.homens), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, { size: "4" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, _toDisplayString(_ctx.churrascometro.mulheres), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, { size: "4" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, _toDisplayString(_ctx.churrascometro.criancas), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_list_header, null, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.churrascometro.resultado.carnes, (itens, index) => {
                    return (_openBlock(), _createBlock(_component_ion_item, {
                      key: 'cav'+index
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(itens.descricao), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_ion_note, {
                          slot: "end",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(itens.calculo), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  _createVNode(_component_ion_list_header, null, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.churrascometro.resultado.acompanhamentos, (itens, index) => {
                    return (_openBlock(), _createBlock(_component_ion_item, {
                      key: 'ca'+index
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(itens.descricao), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_ion_note, {
                          slot: "end",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(itens.calculo), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  _createVNode(_component_ion_list_header, null, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.churrascometro.resultado.suprimentos, (itens, index) => {
                    return (_openBlock(), _createBlock(_component_ion_item, {
                      key: 'cs'+index
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(itens.descricao), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_ion_note, {
                          slot: "end",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(itens.calculo), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  _createVNode(_component_ion_list_header, null, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.churrascometro.resultado.bebidas, (itens, index) => {
                    return (_openBlock(), _createBlock(_component_ion_item, {
                      key: 'cb'+index
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(itens.descricao), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_ion_note, {
                          slot: "end",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(itens.calculo), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _hoisted_12,
                          _hoisted_13,
                          _hoisted_14,
                          _hoisted_15
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open"]),
      _createVNode(_component_SafeArea, {
        onOnBack: _cache[3] || (_cache[3] = ($event: any) => (_ctx.voltar())),
        data: {'cart': false}
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                size: "12",
                class: "ion-text-center font-montserrat font-25 layout_blue"
              }, {
                default: _withCtx(() => [
                  _hoisted_16,
                  _hoisted_17
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, { size: "12" }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, { class: "ion-align-items-center churrascometro" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, { size: "4" }, {
                default: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, { size: "4" }, {
                default: _withCtx(() => [
                  _hoisted_20
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, { size: "4" }, {
                default: _withCtx(() => [
                  _hoisted_21
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, { class: "ion-align-items-center ion-text-center font-montserrat-bold" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, { size: "4" }, {
                default: _withCtx(() => [
                  _hoisted_22
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, { size: "4" }, {
                default: _withCtx(() => [
                  _hoisted_23
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, { size: "4" }, {
                default: _withCtx(() => [
                  _hoisted_24
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, { class: "ion-align-items-center ion-text-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, { size: "4" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_ion_button, {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeValue('homens', '+'))),
                      color: "jauservelayoutalter",
                      shape: "round",
                      size: "large",
                      expand: "full"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          slot: "icon-only",
                          icon: _ctx.iconPlus
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, { size: "4" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_ion_button, {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeValue('mulheres', '+'))),
                      color: "jauservelayoutalter",
                      shape: "round",
                      size: "large",
                      expand: "full"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          slot: "icon-only",
                          icon: _ctx.iconPlus
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, { size: "4" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_ion_button, {
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeValue('criancas', '+'))),
                      color: "jauservelayoutalter",
                      shape: "round",
                      size: "large",
                      expand: "full"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          slot: "icon-only",
                          icon: _ctx.iconPlus
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, { class: "ion-align-items-center ion-text-center font-montserrat-bold" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, { size: "4" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(_ctx.churrascometro.homens), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, { size: "4" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(_ctx.churrascometro.mulheres), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, { size: "4" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(_ctx.churrascometro.criancas), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, { class: "ion-align-items-center ion-text-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, { size: "4" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_ion_button, {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changeValue('homens', '-'))),
                      color: "jauservelayoutalter",
                      shape: "round",
                      size: "large",
                      expand: "full"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          slot: "end",
                          icon: _ctx.iconMinus
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, { size: "4" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_ion_button, {
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.changeValue('mulheres', '-'))),
                      color: "jauservelayoutalter",
                      shape: "round",
                      size: "large",
                      expand: "full"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          slot: "end",
                          icon: _ctx.iconMinus
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, { size: "4" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_ion_button, {
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.changeValue('criancas', '-'))),
                      color: "jauservelayoutalter",
                      shape: "round",
                      size: "large",
                      expand: "full"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          slot: "end",
                          icon: _ctx.iconMinus
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.churrasco_avancado)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createVNode(_component_ion_row, {
                  class: "ion-align-items-center",
                  color: "light"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, { size: "12" }, {
                      default: _withCtx(() => [
                        _hoisted_26
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_accordion_group, { class: "churrascometro" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_accordion, { value: "first" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, {
                          slot: "header",
                          color: "light"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_avatar, { slot: "start" }, {
                              default: _withCtx(() => [
                                _hoisted_27
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _hoisted_28
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_29, [
                          _createVNode(_component_ion_row, null, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.churrascometro.secoes[0].opcoes, (opcao, index) => {
                                return (_openBlock(), _createBlock(_component_ion_col, {
                                  size: "6",
                                  key: 'cb'+index
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_ion_button, {
                                        class: _normalizeClass(["ion-button-small", { 'item-selecionado': opcao.selecionado }]),
                                        onClick: ($event: any) => (_ctx.changeSelect(opcao)),
                                        color: "jauserve",
                                        expand: "full"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(opcao.descricao), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["class", "onClick"])
                                    ])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_accordion, { value: "second" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, {
                          slot: "header",
                          color: "light"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_avatar, { slot: "start" }, {
                              default: _withCtx(() => [
                                _hoisted_30
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _hoisted_31
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_32, [
                          _createVNode(_component_ion_row, null, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.churrascometro.secoes[1].opcoes, (opcao, index) => {
                                return (_openBlock(), _createBlock(_component_ion_col, {
                                  size: "6",
                                  key: 'cs'+index
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_ion_button, {
                                        class: _normalizeClass(["ion-button-small", { 'item-selecionado': opcao.selecionado }]),
                                        onClick: ($event: any) => (_ctx.changeSelect(opcao)),
                                        color: "jauserve",
                                        expand: "full"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(opcao.descricao), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["class", "onClick"])
                                    ])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_accordion, { value: "third" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, {
                          slot: "header",
                          color: "light"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_avatar, { slot: "start" }, {
                              default: _withCtx(() => [
                                _hoisted_33
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _hoisted_34
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_35, [
                          _createVNode(_component_ion_row, null, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.churrascometro.secoes[2].opcoes, (opcao, index) => {
                                return (_openBlock(), _createBlock(_component_ion_col, {
                                  size: "6",
                                  key: 'co'+index
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_ion_button, {
                                        class: _normalizeClass(["ion-button-small", { 'item-selecionado': opcao.selecionado }]),
                                        onClick: ($event: any) => (_ctx.changeSelect(opcao)),
                                        color: "jauserve",
                                        expand: "full"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(opcao.descricao), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["class", "onClick"])
                                    ])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_accordion, { value: "fourth" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, {
                          slot: "header",
                          color: "light"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_avatar, { slot: "start" }, {
                              default: _withCtx(() => [
                                _hoisted_36
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _hoisted_37
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_38, [
                          _createVNode(_component_ion_row, null, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.churrascometro.secoes[3].opcoes, (opcao, index) => {
                                return (_openBlock(), _createBlock(_component_ion_col, {
                                  size: "6",
                                  key: 'cf'+index
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_ion_button, {
                                        class: _normalizeClass(["ion-button-small", { 'item-selecionado': opcao.selecionado }]),
                                        onClick: ($event: any) => (_ctx.changeSelect(opcao)),
                                        color: "jauserve",
                                        expand: "full"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(opcao.descricao), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["class", "onClick"])
                                    ])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, {
                  class: "ion-align-items-center",
                  color: "light"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, {
                      size: "12",
                      class: "ion-padding"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_39
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, { style: {"background":"#f4f5f8"} }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.churrascometro.acompanhamentos, (opcao, index) => {
                      return (_openBlock(), _createBlock(_component_ion_col, {
                        size: "6",
                        key: 'cv'+index
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createVNode(_component_ion_button, {
                              class: _normalizeClass(["ion-button-small", { 'item-selecionado': opcao.selecionado }]),
                              onClick: ($event: any) => (_ctx.changeSelect(opcao)),
                              color: "jauserve",
                              expand: "full"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(opcao.descricao), 1)
                              ]),
                              _: 2
                            }, 1032, ["class", "onClick"])
                          ])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, {
                  class: "ion-align-items-center",
                  color: "light"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, {
                      size: "12",
                      class: "ion-padding"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_40
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, { style: {"background":"#f4f5f8"} }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.churrascometro.suprimentos, (opcao, index) => {
                      return (_openBlock(), _createBlock(_component_ion_col, {
                        size: "6",
                        key: 'cv'+index
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createVNode(_component_ion_button, {
                              class: _normalizeClass(["ion-button-small", { 'item-selecionado': opcao.selecionado }]),
                              onClick: ($event: any) => (_ctx.changeSelect(opcao)),
                              color: "jauserve",
                              expand: "full"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(opcao.descricao), 1)
                              ]),
                              _: 2
                            }, 1032, ["class", "onClick"])
                          ])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, {
                  class: "ion-align-items-center",
                  color: "light"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, {
                      size: "12",
                      class: "ion-padding"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_41
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, { style: {"background":"#f4f5f8"} }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.churrascometro.bebidas, (opcao, index) => {
                      return (_openBlock(), _createBlock(_component_ion_col, {
                        size: "6",
                        key: 'cv'+index
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createVNode(_component_ion_button, {
                              class: _normalizeClass(["ion-button-small", { 'item-selecionado': opcao.selecionado }]),
                              onClick: ($event: any) => (_ctx.changeSelect(opcao)),
                              color: "jauserve",
                              expand: "full"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(opcao.descricao), 1)
                              ]),
                              _: 2
                            }, 1032, ["class", "onClick"])
                          ])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _hoisted_42,
          _hoisted_43,
          _hoisted_44,
          _hoisted_45,
          _hoisted_46
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, { class: "ion-padding" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_button, {
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.goCalcular())),
            shape: "jau",
            size: "large",
            color: "jauservelayoutalter",
            expand: "block",
            disabled: _ctx.churrasco_tipo==0
          }, {
            default: _withCtx(() => [
              _hoisted_47
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}